import { WA_NUMBER } from '@/lib/supabase';

const SOCIALS = [
  { icon: 'facebook-f', url: '#',  aria: 'Facebook' },
  { icon: 'instagram',  url: '#',  aria: 'Instagram' },
  { icon: 'tiktok',     url: '#',  aria: 'TikTok' },
  { icon: 'youtube',    url: '#',  aria: 'YouTube' },
];

export function Footer() {
  return (
    <footer>
      <div className="socials">
        {SOCIALS.map((s) => (
          <a key={s.icon} href={s.url} aria-label={s.aria}>
            <i className={`fab fa-${s.icon}`} />
          </a>
        ))}
        <a
          href={`https://wa.me/${WA_NUMBER}`}
          target="_blank"
          rel="noopener"
          aria-label="WhatsApp"
          style={{ borderColor: 'rgba(37,211,102,.4)', color: 'rgba(37,211,102,.6)' }}
        >
          <i className="fab fa-whatsapp" />
        </a>
      </div>
      <div className="footer-name">LAS POLVILLAS</div>
      <p className="footer-copy">
        © {new Date().getFullYear()} Empacadora Las Polvillas &nbsp;·&nbsp; Todos los derechos reservados
      </p>
    </footer>
  );
}
